import { render } from "./TeamDetailsDialog.vue?vue&type=template&id=38ec7448&scoped=true"
import script from "./TeamDetailsDialog.vue?vue&type=script&lang=js"
export * from "./TeamDetailsDialog.vue?vue&type=script&lang=js"

import "./TeamDetailsDialog.vue?vue&type=style&index=0&id=38ec7448&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ec7448"]])

export default __exports__